"use strict";
exports.__esModule = true;
var lng_lat_1 = require("../geometry/lng-lat");
var bounds_1 = require("../geometry/bounds");
var point_1 = require("../geometry/point");
exports.lngLatProjection = {
    project: function (lngLat) {
        return new point_1.Point(lngLat.lng, lngLat.lat);
    },
    unproject: function (point) {
        return new lng_lat_1.LngLat(point.x, point.y);
    },
    bounds: new bounds_1.Bounds([-180, -90], [180, 90])
};
//# sourceMappingURL=lnglat-projection.js.map